export default __webpack_public_path__ + "static/media/duster-colour-4.7d844ded.jpg";